"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgMinimize = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M5 14.936a1 1 0 010-2h5.071a1 1 0 011 1v5.073a1 1 0 01-2 0v-4.073H5zm14.007-5.863a1 1 0 110 2h-5.071a1 1 0 01-1-1V5a1 1 0 012 0v4.073H19.007z' }))); };
exports.default = SvgMinimize;
//# sourceMappingURL=Minimize.js.map